/**
 * Vivre Control Plane — Theme Colors
 * Based on Vivre FE color spec:
 * - Menu gradient: #00ACC4 → #2F36CB
 * - Highlight: #ffffffb8 (semi-transparent white)
 * - KPI: Green
 * - Warning/Alert: Orange
 * - Error: Red
 */

const colors = {
  background: {
    default: "#F4F6F9",
  },

  text: {
    main: "#5D6D7E",
    focus: "#4A5A6B",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#1B2631",
    main: "#0D1117",
    focus: "#0D1117",
  },

  primary: {
    main: "#2F36CB",
    focus: "#252BAF",
  },

  secondary: {
    main: "#5D6D7E",
    focus: "#4A5A6B",
  },

  info: {
    main: "#00ACC4",
    focus: "#0097AD",
  },

  success: {
    main: "#27AE60",
    focus: "#229954",
  },

  warning: {
    main: "#F39C12",
    focus: "#D68910",
  },

  error: {
    main: "#E74C3C",
    focus: "#CB4335",
  },

  light: {
    main: "#F4F6F9",
    focus: "#EBF0F5",
  },

  dark: {
    main: "#141D46",
    focus: "#0F1636",
  },

  grey: {
    100: "#F8F9FA",
    200: "#F4F6F9",
    300: "#DEE2E6",
    400: "#CED4DA",
    500: "#ADB5BD",
    600: "#6C757D",
    700: "#495057",
    800: "#2C3E50",
    900: "#1B2631",
  },

  gradients: {
    primary: {
      main: "#00ACC4",
      state: "#2F36CB",
    },

    secondary: {
      main: "#6C7A89",
      state: "#4A5568",
    },

    info: {
      main: "#00ACC4",
      state: "#2F36CB",
    },

    success: {
      main: "#2ECC71",
      state: "#27AE60",
    },

    warning: {
      main: "#F5B041",
      state: "#F39C12",
    },

    error: {
      main: "#EC7063",
      state: "#E74C3C",
    },

    light: {
      main: "#EBF0F5",
      state: "#D5DBDB",
    },

    dark: {
      main: "#2F36CB",
      state: "#141D46",
    },
  },

  socialMediaColors: {
    facebook: { main: "#3b5998", dark: "#344e86" },
    twitter: { main: "#55acee", dark: "#3ea1ec" },
    instagram: { main: "#125688", dark: "#0e456d" },
    linkedin: { main: "#0077b5", dark: "#00669c" },
    pinterest: { main: "#cc2127", dark: "#b21d22" },
    youtube: { main: "#e52d27", dark: "#d41f1a" },
    vimeo: { main: "#1ab7ea", dark: "#13a3d2" },
    slack: { main: "#3aaf85", dark: "#329874" },
    dribbble: { main: "#ea4c89", dark: "#e73177" },
    github: { main: "#24292e", dark: "#171a1d" },
    reddit: { main: "#ff4500", dark: "#e03d00" },
    tumblr: { main: "#35465c", dark: "#2a3749" },
  },

  badgeColors: {
    primary: {
      background: "#D6EAF8",
      text: "#2F36CB",
    },

    secondary: {
      background: "#D5DBDB",
      text: "#4A5568",
    },

    info: {
      background: "#D1F2EB",
      text: "#00ACC4",
    },

    success: {
      background: "#D5F5E3",
      text: "#1E8449",
    },

    warning: {
      background: "#FDEBD0",
      text: "#9A7D0A",
    },

    error: {
      background: "#FADBD8",
      text: "#922B21",
    },

    light: {
      background: "#ffffff",
      text: "#ADB5BD",
    },

    dark: {
      background: "#85929E",
      text: "#141D46",
    },
  },

  coloredShadows: {
    primary: "#2F36CB",
    secondary: "#5D6D7E",
    info: "#00ACC4",
    success: "#27AE60",
    warning: "#F39C12",
    error: "#E74C3C",
    light: "#ADB5BD",
    dark: "#141D46",
  },

  inputBorderColor: "#D5DBDB",

  tabs: {
    indicator: { boxShadow: "#D5DBDB" },
  },
};

export default colors;
